export { supportedFonts } from 'lib/fonts/brand.generated';
